/** Subscriber id from a Listmonk campaign link (`?lm=`), stored in `_lm`. */
export const LISTMONK_VISITOR_COOKIE = "_lm";
export const LISTMONK_VISITOR_PARAM = "lm";

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isListmonkVisitorId(value: string | null | undefined): value is string {
  return typeof value === "string" && UUID_RE.test(value);
}

/** Query param wins. An invalid param falls back to the cookie. */
export function resolveListmonkVisitorId(
  search: string,
  cookieValue: string | null | undefined,
): string | null {
  const query = new URLSearchParams(search.replace(/^\?/, "")).get(LISTMONK_VISITOR_PARAM);
  if (isListmonkVisitorId(query)) return query;
  if (isListmonkVisitorId(cookieValue)) return cookieValue;
  return null;
}
